<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-01-28 11:01:06
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-01-28 12:55:34
-->
<template>
  <div class="PasswordLogin">
    <Form :model="form" :rules="rules" v-model="regular">
      <Input
        label=""
        class="temr"
        v-model="form.password"
        :reg="rules.password"
        :maxlength="12"
        :type="type"
        labelWidth="90px"
        placeholder="新密码"
      />
      <Input
        label=""
        class="temr"
        v-model="form.passwordCopy"
        :reg="rules.passwordCopy"
        :maxlength="12"
        :type="type"
        labelWidth="90px"
        placeholder="确认密码"
      />
    </Form>
    <Button
      :loading="loading"
      loadingText="提交中..."
      type="danger"
      text="保存新密码"
      :disabled="!regular"
      class="nextStep"
      :click="nextStep"
    />
    <self-popup @define="define" v-model="ShowContent"></self-popup>
  </div>
</template>

<script>
import { rules } from '@/utils';
import Form from '@/components/Form.vue';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import JSencrypt from '@/utils/rsa/jsencrypt';

export default {
  name: 'PasswordLogin',
  data() {
    return {
      type: 'password',
      form: {
        passwordCopy: '',
        password: '',
      },
      rules: {
        passwordCopy: rules.password,
        password: rules.password,
      },
      loading: false,
      regular: false,
      ShowContent: '',
    };
  },
  components: {
    Form,
    Input,
    Button,
  },
  computed: {},
  methods: {
    nextStep() {
      const flag = this.form.passwordCopy !== this.form.password;
      if (flag) {
        (this.ShowContent = '两次密码输入不一致');
        return;
      }
      const obj = {
        phone: this.$router.currentRoute.query.phoneForReset,
        password: this.form.password,
      };
      const encrypt = new JSencrypt();
      encrypt.setPublicKey(
        'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJw/nF+v0qHYsf5TxSVN97iHMydfBEsfCAVSSBSvxXtcWOOZN3fpeNoH9P5KPpxF9+BVrAynIV4dIFgRhE58aRECAwEAAQ==',
      );
      obj.phone = encrypt.encrypt(obj.phone);
      obj.password = encrypt.encrypt(obj.password);
      this.$api.PublicPage.updatePassword(JSON.stringify(obj))
        .then((res) => {
          if (res.success) {
            this.ShowContent = '重置密码成功';
          } else {
            this.ShowContent = res.returnMessage;
          }
        })
        .catch((e) => {
          this.ShowContent = e;
        });
    },
    define(obj) {
      if (obj.value === '重置密码成功') {
        this.$router.push('/supermarket/v2/login');
      }
      this.ShowContent = '';
      // eslint-disable-next-line no-unused-expressions
      obj.cb && obj.cb();
    },
  },
};
</script>
<style scoped>
.nextStep {
  margin-top: 32px;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;

  border-bottom: 1px solid #DDDEE1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
</style>
